import React, { useState } from 'react';
import { Box, TextField, Button, Typography, Paper } from '@mui/material';

export default function Chat() {
  const [messages, setMessages] = useState([]);
  const [inputValue, setInputValue] = useState('');

  const handleSend = async () => {
    if (!inputValue.trim()) return;

    // Add user message to chat
    const newMessages = [
      ...messages,
      { role: 'user', content: inputValue.trim() },
    ];
    setMessages(newMessages);
    setInputValue('');

    try {
      // Call Cloudflare Pages Function
      const response = await fetch('https://pinecone-gpt-worker.morning-haze-43ce.workers.dev', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ userMessage: inputValue.trim() }),
      });

      if (!response.ok) {
        console.error('Error from server:', response.statusText);
        return;
      }

      const data = await response.json();
      const assistantMessage = data.assistantMessage;

      // Add assistant message to chat
      setMessages((prev) => [
        ...prev,
        { role: 'assistant', content: assistantMessage },
      ]);
    } catch (err) {
      console.error('Request failed:', err);
    }
  };

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        margin: '0 auto',
        width: '100%',
        maxWidth: '600px',
        p: 2,
      }}
    >
      <Typography variant="h4" gutterBottom>
        GPT Chatbot
      </Typography>

      <Paper
        variant="outlined"
        sx={{
          flex: 1,
          p: 2,
          marginBottom: 2,
          height: '400px',
          overflowY: 'auto',
          display: 'flex',
          flexDirection: 'column-reverse',
        }}
      >
        <Box display="flex" flexDirection="column-reverse">
          {messages
            .slice()
            .reverse()
            .map((msg, index) => (
              <Box
                key={index}
                sx={{
                  mb: 1,
                  textAlign: msg.role === 'assistant' ? 'left' : 'right',
                }}
              >
                <Typography
                  variant="body1"
                  sx={{
                    backgroundColor:
                      msg.role === 'assistant' ? '#f5f5f5' : '#c8e6c9',
                    display: 'inline-block',
                    padding: '8px 12px',
                    borderRadius: '8px',
                  }}
                >
                  <strong>{msg.role === 'assistant' ? 'Bot' : 'You'}:</strong>{' '}
                  {msg.content}
                </Typography>
              </Box>
            ))}
        </Box>
      </Paper>

      <Box display="flex" gap={1}>
        <TextField
          fullWidth
          variant="outlined"
          placeholder="Type your message..."
          value={inputValue}
          onChange={(e) => setInputValue(e.target.value)}
          onKeyDown={(e) => {
            if (e.key === 'Enter') {
              e.preventDefault();
              handleSend();
            }
          }}
        />
        <Button variant="contained" onClick={handleSend}>
          Send
        </Button>
      </Box>
    </Box>
  );
}
